<template>
  <div :class="['dr-dp-designer-panel-height', 'd-flex']">

    <v-container v-if="!autoHide">
      <div class="d-flex align-center">
        <v-btn class="pin-button" icon @click="setTrueAutoHide()" isAutoHidePropPanel="true">
          <v-icon :class="[{'auto-hiden':autoHide}]">mdi-pin</v-icon>
        </v-btn>
        <v-tabs :value="tab" :center-active="true" @change="changeTab">
          <v-tab v-for="(item, index) in items" :key="index">{{ item.name }}</v-tab>
        </v-tabs>
      </div>
    </v-container>

    <v-container  v-else>
      <v-row align="center" >
        <v-col cols="3" align="start" class="pl-0">
          <v-btn icon @click="setFalseAutoHide()" class="ml-1">
            <v-icon :class="[{'auto-hiden':autoHide}]">mdi-pin</v-icon>
          </v-btn>
        </v-col>
        <v-col  align="center" cols="6">
          <span class="mr-3">{{items[tab].name}}</span>
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>
    </v-container>
    
    <v-tabs-items
      v-model="tab"
      :class="['dr-dp-tabs-items-scroll', {'pr-2': !autoHide}, {'pl-2': tab === 1 && !autoHide}]"
    >
      <v-tab-item
        v-for="(item, index) in items"
        :key="index"
        :hide-slider="true"
      >
      <v-text-field
        v-if="item.value === 0"
        v-model="searchVal"
        label="Search"
        class="mx-4"
      ></v-text-field>

        <template v-if="item.value === 0">
          <div
            v-for="(group, index) in components"
            :key="index"
          >
            <p class="dr-dp-component-group-header">{{ index }}</p>
            <draggable
              :clone="onCloneWidget"
              :group="{ name: 'toolbox', pull: 'clone', put: 'false' }"
              :swapThreshold="0.95"
              :emptyInsertThreshold="20"
              :sort="false"
              v-model="components[index]"
            >
              <div  v-for="(comp, i) in group" :key="i">
                <div
                  v-if="comp.allowInToolbox"
                  class="dr-dp-designer-container"
                >
                  <dr-designer-component
                    :style="autoHide ? 'margin-left: 0px !important' : ''"
                    :component="comp"
                  ></dr-designer-component>
                </div>
              </div>
            </draggable>
          </div>
        </template>
        <template v-else>
          <div
            class="dr-dp-header-props-component-title"
            v-if="selectedComponentSchema"
          >
            <span>{{ selectedComponentSchema.name }}: {{ value.$ID }}</span>
          </div>
          <portal-target v-if="value" name="action-buttons"></portal-target>
          <dr-property-panel
            :style="autoHide ? 'margin-left: 0px !important' : ''"
            v-if="selectedComponentSchema"
            :schema="selectedComponentSchema"
            :readonly="readonly"
            v-model="localValue"
            :contract="contract"
          ></dr-property-panel>
        </template>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { componentsModels } from '../../widgets'
import baseMixin from '../../mixins/base-mixin'
import propertyPanelMixin from '../../mixins/propertyPanel-mixin'

export default {
  mixins: [baseMixin, propertyPanelMixin],
  props: ['value', 'readonly', 'tab', 'autoHide', 'contract'],
  data() {
    return {
      clonedWidget: null,
      searchVal: ''
    }
  },
  computed: {
    selectedComponentSchema() {
      let schema = ''
      for (const key in this.components) {
        schema = this.components[key].find(
          el => el.$Type == (this.value || {}).$Type
        )
        if (schema) {
          return schema
        }
      }
      return schema
    },
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    filteredComponents() {
      if (this.searchVal) {
        return componentsModels.filter(element => {
          if (element.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) >= 0 ) {
            return true
          }
          return false
        })
      }
      return componentsModels
      
    },
    components() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      let models = this.filteredComponents.sort((a, b) =>
        a.group > b.group ? 1 : a.group < b.group ? -1 : 0
      ) 
      let newModel = {}
      for (let model of models) {
        if (!newModel[model.group]) {
          newModel[model.group] = []
        }
        newModel[model.group].push(model)
      }
      return newModel
    }
  },
  methods: {
    changeTab(value) {
      this.$emit('changeTab', value)
    },
    setTrueAutoHide() {
      this.$emit('changeAutoHide', true)
    },
    setFalseAutoHide() {
      this.$emit('changeAutoHide', false)
    },
    onCloneWidget(designWidget) {
      // создаем объект, который будем добавлять
      let widget = {
        $Type: designWidget.$Type
      }
      for (let prop in designWidget.properties) {
        var propObject = designWidget.properties[prop]
        let propDefVal = undefined
        // может быть задано значение по умолчанию
        if (propObject.default !== undefined) {
          propDefVal = JSON.parse(JSON.stringify(propObject.default))
        } else {
          switch (propObject.type) {
            case 'string':
              propDefVal = ''
              break
            case 'integer':
              propDefVal = 0
              break
            case 'array':
              propDefVal = []
              break
            case 'object':
              propDefVal = {}
          }
        }
        // генерим айдишники
        if (prop == '$ID') {
          propDefVal = Math.random() + ''
        }

        //Заглушка для новосозданного табличного макета
        if (prop == 'Rows' && widget.$Type == 'dr-grid-layout') {
          propDefVal[0].$ID = Math.random() + ''
          propDefVal[0].$Type = 'dr-grid-layout-row'

          for (let i in propDefVal[0].Columns) {
            for (let j in propDefVal[0].Columns[i]) {
              if (j == '$ID') {
                propDefVal[0].Columns[i].$ID = Math.random() + ''
                propDefVal[0].Columns[i].$Type = 'dr-grid-layout-column'
              }
            }
          }
        }
        widget[prop] = propDefVal
      }
      this.clonedWidget = widget
      return widget
    }
  },
  watch: {
    tab(val) {
      if (val) {
        this.searchVal = ''
      }
    }
  }
}
</script>

<style lang="scss">
.dr-dp-designer-panel-height {
  height: 100%;
  display: flex;
  flex-direction: column;
  .v-tabs{
    flex: 0;
  }
}

.dr-dp-component-group-header {
  text-align: center;
  width: 100%;
  color: rgba(0, 0, 0, 0.5);
  margin: 0px !important;
  user-select: none;
}
.dr-dp-designer-container {
  padding: 4px;
  flex: auto;
  margin: 0px !important;
}
.dr-dp-tabs-items-scroll {
  flex: 1 0 0;
  overflow: auto !important;
}
.dr-dp-header-props-component-title {
  padding-top: 5px;
  padding-left: 12px;
  font-size: 14px;
  user-select: none;
}
.dr-dp-widgets-container {
  padding: 5px;
}

.auto-hiden {
  transform: rotate(90deg);
}

.pin-button {
  width: 36px;
}
</style>
